const MINOR_IN_MAJOR = 100;
export function toMinor(major) {
    return Math.round(major * MINOR_IN_MAJOR);
}
export function toMajor(minor) {
    return minor / MINOR_IN_MAJOR;
}
const CURRENCY_LOCALE = {
    RUB: 'ru-RU',
    KZT: 'ru-KZ',
    USD: 'en-US',
    EUR: 'de-DE',
};
export function formatMoney(minor, currency = 'KZT') {
    return new Intl.NumberFormat(CURRENCY_LOCALE[currency] ?? 'ru-RU', {
        style: 'currency',
        currency,
        maximumFractionDigits: minor % MINOR_IN_MAJOR === 0 ? 0 : 2,
    }).format(toMajor(minor));
}
/**
 * Часы тоже хранятся целыми — в минутах. Баланс ученика может быть
 * отрицательным: это долг за уроки, проведённые в кредит.
 */
export function minutesToHours(minutes) {
    return minutes / 60;
}
export function hoursToMinutes(hours) {
    return Math.round(hours * 60);
}
/** «2 ч 30 мин», «−1 ч», «45 мин». Для компактных мест в интерфейсе. */
export function formatDuration(minutes) {
    const sign = minutes < 0 ? '−' : '';
    const abs = Math.abs(minutes);
    const hours = Math.floor(abs / 60);
    const rest = abs % 60;
    if (hours === 0)
        return `${sign}${rest} мин`;
    if (rest === 0)
        return `${sign}${hours} ч`;
    return `${sign}${hours} ч ${rest} мин`;
}
/** Склонение: 1 час, 2 часа, 5 часов. */
export function pluralizeHours(hours) {
    const abs = Math.abs(Math.trunc(hours));
    const lastTwo = abs % 100;
    const last = abs % 10;
    if (lastTwo >= 11 && lastTwo <= 14)
        return 'часов';
    if (last === 1)
        return 'час';
    if (last >= 2 && last <= 4)
        return 'часа';
    return 'часов';
}
//# sourceMappingURL=units.js.map